export const baseApiEndpoint =
  import.meta.env.VITE_APP_BASE_URL ||
  'https://api-dev.fafu.com.vn/fdo-service/api';
